<template>
  <router-view />
</template>

<style lang="scss">
// 3rd party plugins css
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~animate.css";
@import "~@fortawesome/fontawesome-free/css/all.css";

// Main demo style scss
@import "assets/sass/style.vue";

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/
</style>

<script>
import { mapGetters } from 'vuex'
import { eventBus } from './main'
import { showToast } from '@/core/utils'
import { OVERRIDE_LAYOUT_CONFIG, HANDLE_APP_VERSION } from '@/core/services/store/config.module'
import { VERIFY_AUTH } from '@/core/services/store/auth.module'
import { GET_EVENTS_COUNT } from '@/core/services/store/notifications.module'

const ACTIVE_INTERVAL   = 15000   // 15 sec
const UNACTIVE_INTERVAL = 300000  // 5 min
const VERSION_INTERVAL  = 3600000 // 1 hour

export default {
  name: 'App',
  data() {
    return {
      authTimer: null,
      notificationsInterval: ACTIVE_INTERVAL,
      notificationsTimer: null,

      showToast,
    }
  },
  computed: {
    ...mapGetters(['currentUser']),

    currentRoute() {
      return this.$route
    },
  },
  watch: {
    /* eslint-disable-next-line no-unused-vars */
    currentRoute(newVal, oldVal) {
      if (newVal.name == 'Notifications') {
        this.clearNotificationsInterval()
      }
    },
  },
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG)
    this.$store.dispatch(HANDLE_APP_VERSION)
    setInterval(() => {
      this.$store.dispatch(HANDLE_APP_VERSION)
    }, VERSION_INTERVAL)

    this.refreshAuth()
    this.checkNotificationsCount()
    this.setNotificationsInterval()
    this.handleVisibilityChange()

    eventBus.$on('refreshAuth', () => { this.setAuthInterval() })
    eventBus.$on('clearNotificationsInterval', () => { this.clearNotificationsInterval()})
    eventBus.$on('restartNotificationsTimer', () => { this.setNotificationsInterval() })
    eventBus.$on('checkNotificationsCount', () => { this.checkNotificationsCount() })
    eventBus.$on('showToast', ({ message, variant }) => { this.showToast(message, variant) })
  },
  methods: {
    setAuthInterval() {
      this.clearAuthInteval()
      this.authTimer = setInterval(() => {
        this.refreshAuth()
      }, (this.currentUser.ttl - 15) * 1000)
    },

    clearAuthInteval() {
      clearInterval(this.authTimer)
    },

    refreshAuth() {
      this.$store.dispatch(VERIFY_AUTH)
    },

    setNotificationsInterval() {
      this.notificationsTimer = setInterval(() => {
        this.checkNotificationsCount()
      }, this.notificationsInterval)
    },

    clearNotificationsInterval() {
      clearInterval(this.notificationsTimer)
    },

    checkNotificationsCount() {
      this.$store.dispatch(GET_EVENTS_COUNT)
    },

    handleVisibilityChange() {
      document.addEventListener('visibilitychange', () => {
        this.clearNotificationsInterval()
        this.notificationsInterval = document.hidden ? UNACTIVE_INTERVAL : ACTIVE_INTERVAL
        this.setNotificationsInterval()
      })
    },
  },
}
</script>
